import { NavLink } from 'react-router';

import type { TopBarProps as BumblebeeTopBarProps } from '@shieldpay/bumblebee/top-bar';
import { TopBar as BumblebeeTopBar } from '@shieldpay/bumblebee/top-bar';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

export const TopBar = ({
  ...props
}: RemoveNavLinkProperty<BumblebeeTopBarProps>) => {
  return <BumblebeeTopBar {...props} NavLink={NavLink} />;
};
